import React, { Component } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Chip,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { keyframes } from "@mui/system";
import { Link } from "react-router-dom";

// Ícones MUI
import BoltIcon from "@mui/icons-material/Bolt";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

import desktopImageUrl from "../../../../src/images/desktop.png";
import mobile from "../../../../src/images/mobile.png";

const mobileImageUrl =
  mobile;

// Animação de pulso e brilho para o botão de CTA principal
const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(124, 58, 237, 0.7), 0 10px 25px -5px rgba(124, 58, 237, 0.4);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 0 14px rgba(124, 58, 237, 0), 0 15px 30px -5px rgba(124, 58, 237, 0.6);
    transform: scale(1.02);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(124, 58, 237, 0), 0 10px 25px -5px rgba(124, 58, 237, 0.4);
    transform: scale(1);
  }
`;

class Apresentacao extends Component {
  render() {
    return (
      <Box
        component="section"
        id="apresentacao"
        sx={{ bgcolor: "background.paper", py: { xs: 4, sm: 8 } }}
      >
        <Container maxWidth="xl">
          <Grid container spacing={{ xs: 4, lg: 6 }} alignItems="center">
            {/* Conteúdo de Texto e Ações */}
            <Grid
              size={{ xs: 12, lg: 6 }}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "center", lg: "flex-start" },
                textAlign: { xs: "center", lg: "left" },
              }}
            >
              {/* Tag de Destaque abrangente */}
              <Chip
                icon={<BoltIcon sx={{ color: "#7C3AED !important" }} />}
                label="SUA LOJA ONLINE | PEDIDOS DIRECT | ZERO COMISSÃO"
                sx={{
                  bgcolor: "#F2ECFF",
                  color: "#7C3AED",
                  fontWeight: 700,
                  fontSize: "0.75rem",
                  border: "1px solid rgba(124, 58, 237, 0.3)",
                  mb: 3,
                }}
              />

              {/* Título Principal Focado em Vendas Gerais e Migração de Marketplace */}
              <Typography
                variant="h2"
                component="h1"
                sx={{
                  fontWeight: 800,
                  color: "#1E1B4B",
                  fontSize: { xs: "2rem", sm: "2.75rem", lg: "3.25rem" },
                  lineHeight: 1.2,
                  mb: 2,
                }}
              >
                Crie sua Loja Virtual e Venda Direto sem Pagar Taxas por Venda
              </Typography>

              {/* Parágrafo Descritivo Geral */}
              <Typography
                variant="body1"
                sx={{
                  color: "#464467",
                  fontSize: { xs: "1rem", sm: "1.125rem" },
                  mb: 3,
                  maxWidth: "600px",
                }}
              >
                Ideal para lojistas, varejo, prestadores de serviço e delivery. Tenha seu catálogo próprio para receber pedidos, organize seu estoque e pare de perder margem de lucro para taxas de marketplaces.
              </Typography>

              {/* Lista de Benefícios Abrangentes */}
              <List disablePadding sx={{ mb: 4, width: "100%", maxWidth: "600px" }}>
                {[
                  {
                    title: "Catálogo e Loja Virtual com ",
                    bold: "link próprio e Checkout rápido",
                    end: ".",
                  },
                  {
                    bold: "Ideal para qualquer comércio: ",
                    end: "Roupas, Eletrônicos, Mercados, Comida e Serviços.",
                  },
                  {
                    title: "Gestão completa de ",
                    bold: "pedidos, clientes e estoque",
                    end: " sem complicação.",
                  },
                ].map((item, index) => (
                  <ListItem key={index} disableGutters sx={{ py: 0.5 }}>
                    <ListItemIcon sx={{ minWidth: 32 }}>
                      <CheckCircleOutlineIcon sx={{ color: "#7C3AED" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#3F3E63",
                            fontSize: { xs: "0.9rem", sm: "1.1rem" },
                          }}
                        >
                          {item.title}
                          <strong>{item.bold}</strong>
                          {item.end}
                        </Typography>
                      }
                    />
                  </ListItem>
                ))}
              </List>

              {/* Botões de Ação com o CTA animado */}
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                sx={{
                  width: "100%",
                  mb: 4,
                  justifyContent: { xs: "center", lg: "flex-start" },
                }}
              >
                <Button
                  variant="contained"
                  component={Link}
                  to="/auth/register"
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    bgcolor: "#7C3AED",
                    "&:hover": {
                      bgcolor: "#6D28D9",
                    },
                    borderRadius: "50px",
                    px: 4,
                    py: 1.8,
                    fontSize: "1.05rem",
                    fontWeight: 700,
                    textTransform: "none",
                    letterSpacing: "0.2px",
                    animation: `${pulseAnimation} 2.5s infinite ease-in-out`,
                    transition: "all 0.3s ease",
                  }}
                >
                  Criar Minha Loja Grátis Agora
                </Button>

                <Button
                  variant="text"
                  href="/demo/watch"
                  startIcon={<ArrowForwardIcon />}
                  sx={{
                    color: "#7C3AED",
                    fontWeight: 600,
                    textTransform: "none",
                    "&:hover": { bgcolor: "rgba(124, 58, 237, 0.08)" },
                  }}
                >
                  Ver Loja Demonstração
                </Button>
              </Stack>

              {/* Tags Informativas focadas no lojista geral */}
              <Stack
                direction="row"
                spacing={1}
                flexWrap="wrap"
                useFlexGap
                sx={{ justifyContent: { xs: "center", lg: "flex-start" } }}
              >
                {[
                  { label: "Venda no WhatsApp e Instagram", icon: <StorefrontIcon /> },
                  { label: "Controle de Entregas e Envios", icon: <LocalShippingIcon /> },
                  { label: "Emissão de Comprovantes", icon: <ReceiptLongIcon /> },
                ].map((item) => (
                  <Chip
                    key={item.label}
                    icon={React.cloneElement(item.icon, {
                      sx: { color: "#7C3AED !important", fontSize: "16px" },
                    })}
                    label={item.label}
                    variant="outlined"
                    size="small"
                    sx={{
                      borderColor: "#D8D4FE",
                      bgcolor: "#F4F2FF",
                      color: "#6B6790",
                      fontWeight: 600,
                      py: 0.5,
                    }}
                  />
                ))}
              </Stack>

              {/* Imagem Mobile (Exibida apenas em telas pequenas via sx) */}
              <Box
                sx={{
                  display: { xs: "block", lg: "none" },
                  mt: 5,
                  position: "relative",
                  borderRadius: "28px",
                  p: 1,
                  bgcolor: "#1E1B4B",
                  boxShadow: "0 20px 30px -10px rgba(0,0,0,0.3)",
                  maxWidth: 320,
                  mx: "auto",
                }}
              >
                <Box
                  component="img"
                  src={mobileImageUrl}
                  alt="Interface de pedidos e catálogo online"
                  sx={{
                    width: "100%",
                    borderRadius: "20px",
                    display: "block",
                    objectFit: "cover",
                  }}
                />
              </Box>
            </Grid>

            {/* Imagem Desktop (Exibida apenas em telas grandes via sx) */}
            <Grid
              size={{ lg: 6 }}
              sx={{ display: { xs: "none", lg: "block" } }}
            >
              <Box
                sx={{
                  position: "relative",
                  mx: "auto",
                  maxWidth: 600,
                  borderRadius: "24px",
                  p: 1.5,
                  background:
                    "linear-gradient(135deg, #7C3AED 0%, #1E1B4B 100%)",
                  boxShadow: "0 25px 50px -12px rgba(124, 58, 237, 0.35)",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-5px)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={desktopImageUrl}
                  alt="Dashboard do FazPedido para gestão de vendas"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = mobileImageUrl;
                  }}
                  sx={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "16px",
                    display: "block",
                    objectFit: "cover",
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  }
}

export default Apresentacao;